<template>
  <section class="illustration-gallery">
    <div class="illustration-gallery__toolbar">
      <div class="illustration-gallery__toolbar--search">
        <input type="text" v-model="search" :placeholder="content.search" />
        <img src="../assets/images/search-dots.svg" />
      </div>

      <div class="illustration-gallery__toolbar--scale">
        <img class="icon" src="../assets/images/grid.svg" />
        <vue-slider class="slider" v-model="scale" />
        <img class="icon" src="../assets/images/square.svg" />
      </div>

      <div class="illustration-gallery__toolbar--filter">
        <select class="dropdown" v-model="filter">
          <option value="" selected>{{ content.filter }}</option>
          <option
            v-for="(filter, i) in content.filters"
            :key="`filter_${i}`"
            :value="filter"
          >
            {{ filter }}
          </option>
        </select>
      </div>
    </div>
    <div class="illustration-gallery__grid">
      <div
        v-for="(item, i) in filteredItems.slice(0, this.loaded)"
        :key="`item_${i}`"
        class="illustration-gallery__grid--item"
        :style="`width: ${scale - 2}%`"
      >
        <a
          :href="`https://s3.eu-west-1.amazonaws.com/brand-box.marketing.just-eat.com/downloads/illustrations/${item.name}.png`"
          target="_blank"
          download
        >
          <img :src="require(`../assets/images/${item.name}.png`)"
        /></a>
      </div>
    </div>
    <div class="illustration-gallery__refresh">
      <img
        v-if="content.items.length > loaded"
        src="../assets/images/refresh.svg"
        @click="loadMore"
      />
    </div>
  </section>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'IllustrationGallery',
  components: {
    VueSlider,
  },
  props: {
    content: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    filteredItems() {
      return this.content.items
        .filter((item) =>
          this.search !== ''
            ? item.name.toLowerCase().includes(this.search.toLowerCase())
            : item
        )
        .filter((item) =>
          this.filter !== ''
            ? item.type.toLowerCase().includes(this.filter.toLowerCase())
            : item
        )
    },
  },
  data() {
    return {
      search: '',
      scale: 20,
      filter: '',
      loaded: 10,
    }
  },
  methods: {
    loadMore() {
      this.loaded += 10
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.illustration-gallery {
  width: 100%;
  &__toolbar {
    padding: 20px 0;
    border-bottom: 2px solid var(--color-charcoal-1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--search {
      width: 20%;
      margin: 0 3%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media (max-width: $tablet) {
        width: 100%;
        margin: 20px 0;
      }
      input {
        border: none;
        width: 80%;
        font-family: 'JETSans-Regular', sans-serif;
        background-color: transparent;
      }
      img {
        width: 30px;
      }
    }
    &--scale {
      width: 30%;
      margin: 0 -10%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .slider {
        width: 100% !important;
      }
      .icon {
        margin: 0 10px;
      }
      @media (max-width: $tablet) {
        width: 100%;
        margin: 20px 0;
      }
    }
    &--filter {
      width: 20%;
      @media (max-width: $tablet) {
        width: 100%;
        margin: 20px 0;
      }
    }
  }
  &__grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    height: 700px;
    overflow: scroll;
    &--item {
      margin: 1%;
      img {
        width: 100%;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
  &__refresh {
    text-align: center;
    margin-top: 20px;
    cursor: pointer;
    img {
      width: 50px;
    }
    &:hover {
      transform: scale(1.1);
    }
  }
}
.icon {
  width: 30px;
}
.vue-slider-dot-tooltip {
  display: none;
}
.vue-slider-process,
.vue-slider:hover .vue-slider-process {
  background-color: var(--color-charcoal-1);
  border: none;
}
.vue-slider-dot-handle-focus,
.vue-slider-dot-handle {
  border-color: var(--color-charcoal-1);
  background-color: var(--color-charcoal-1);
  border: 2px solid var(--color-charcoal-1);
  box-shadow: none;
}
.vue-slider:hover .vue-slider-dot-handle-focus,
.vue-slider:hover .vue-slider-dot-handle:hover,
.vue-slider:hover .vue-slider-dot-handle {
  border-color: var(--color-charcoal-1);
}
</style>